import { render, staticRenderFns } from "./ProductInventoryDetail.vue?vue&type=template&id=440252bc&scoped=true"
import script from "./ProductInventoryDetail.vue?vue&type=script&lang=js"
export * from "./ProductInventoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440252bc",
  null
  
)

export default component.exports